// Copyright 2020
//   __  __                       _           _     _   _            _ _   _     
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__  
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \ 
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//                                                                              
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/trait/thermal/v1/thermal.proto (package msh.trait.thermal.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { FloatValue, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message msh.trait.thermal.v1.ThermalTrait
 */
export const ThermalTrait = proto3.makeMessageType(
  "msh.trait.thermal.v1.ThermalTrait",
  [],
);

/**
 * @generated from enum msh.trait.thermal.v1.ThermalTrait.ThermalLevel
 */
export const ThermalTrait_ThermalLevel = proto3.makeEnum(
  "msh.trait.thermal.v1.ThermalTrait.ThermalLevel",
  [
    {no: 0, name: "THERMAL_LEVEL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "THERMAL_LEVEL_NORMAL", localName: "NORMAL"},
    {no: 2, name: "THERMAL_LEVEL_WARNING", localName: "WARNING"},
    {no: 3, name: "THERMAL_LEVEL_EXCEEDED", localName: "EXCEEDED"},
  ],
);

/**
 * @generated from enum msh.trait.thermal.v1.ThermalTrait.ThermalUnit
 */
export const ThermalTrait_ThermalUnit = proto3.makeEnum(
  "msh.trait.thermal.v1.ThermalTrait.ThermalUnit",
  [
    {no: 0, name: "THERMAL_UNIT_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "THERMAL_UNIT_CELSIUS", localName: "CELSIUS"},
    {no: 2, name: "THERMAL_UNIT_FAHRENHEIT", localName: "FAHRENHEIT"},
  ],
);

/**
 * @generated from message msh.trait.thermal.v1.ThermalTrait.ThermalReading
 */
export const ThermalTrait_ThermalReading = proto3.makeMessageType(
  "msh.trait.thermal.v1.ThermalTrait.ThermalReading",
  () => [
    { no: 1, name: "temperature", kind: "message", T: FloatValue },
    { no: 2, name: "target", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "unit_system", kind: "enum", T: proto3.getEnumType(ThermalTrait_ThermalUnit) },
    { no: 4, name: "thermal_level", kind: "enum", T: proto3.getEnumType(ThermalTrait_ThermalLevel) },
  ],
  {localName: "ThermalTrait_ThermalReading"},
);

/**
 * ----------- Commands ----------- //
 *
 * @generated from message msh.trait.thermal.v1.ThermalTrait.Command
 */
export const ThermalTrait_Command = proto3.makeMessageType(
  "msh.trait.thermal.v1.ThermalTrait.Command",
  [],
  {localName: "ThermalTrait_Command"},
);

/**
 * ----------- EVENTS ----------- //
 *
 * @generated from message msh.trait.thermal.v1.ThermalTrait.ThermalChangedEvent
 */
export const ThermalTrait_ThermalChangedEvent = proto3.makeMessageType(
  "msh.trait.thermal.v1.ThermalTrait.ThermalChangedEvent",
  () => [
    { no: 2, name: "thermal_reading", kind: "message", T: ThermalTrait_ThermalReading },
  ],
  {localName: "ThermalTrait_ThermalChangedEvent"},
);

